var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"articles"},[_c('div',{staticClass:"container"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('hr'),_c('slider')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }